import { cloneDeep, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { change as changeFormField, formValueSelector } from 'redux-form';

import { del, success as delSuccess } from '../../actions/procedure/delete';
import { exportPdfProcedure } from '../../actions/procedure/exportPdf';
import { reset, retrieve, update } from '../../actions/procedure/update';
import CategoryTreeSelectionForm from '../category/UpdateTree';
import Backdrop from '../drawer/Backdrop/Backdrop';
import SideDrawer from '../drawer/SideDrawer/SideDrawer';
import Form from './Form';

class Update extends Component {
  state = {
    procedureModals: {},
    sideDrawerOpen: false,
    redirectToList: false,
    isSticky: false,
    isSaving: false,
    saveQueued: false,
    // When we skip store_tree (e.g. unresolved new step), the PUT response still updates Redux.
    // Don't replace the tree from that response or we overwrite correct local order with DB order.
    skipTreeSyncUntilNextStoreTree: false
  };

  static propTypes = {
    retrieved: PropTypes.object,
    retrieveLoading: PropTypes.bool.isRequired,
    retrieveError: PropTypes.string,
    updateLoading: PropTypes.bool.isRequired,
    updateError: PropTypes.string,
    deleteLoading: PropTypes.bool.isRequired,
    deleteError: PropTypes.string,
    updated: PropTypes.object,
    deleted: PropTypes.object,
    eventSource: PropTypes.instanceOf(EventSource),
    retrieve: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    del: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.retrieve(decodeURIComponent(this.props.match.params.id));
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.props.reset(this.props.eventSource);
    window.removeEventListener('scroll', () => this.handleScroll);
  }

  handleScroll = () => {
    if (this._stickyHeader) {
      this.setState({
        isSticky: window.scrollY > 86
        //isSticky: this._stickyHeader.getBoundingClientRect().top <= 0
      });
    }
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (
      this.props.match.params.id &&
      ((this.props.updated &&
        this.props.updated['@id'] &&
        this.props.updated['@id'] !==
          decodeURIComponent(this.props.match.params.id)) ||
        (this.props.retrieved &&
          this.props.retrieved['@id'] &&
          this.props.retrieved['@id'] !==
            decodeURIComponent(this.props.match.params.id)))
    ) {
      return true;
    }

    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  attachNode = node => {
    this._form = node;
  };

  getFormComponent = () => {
    return this._form;
  };

  requestProcedureSubmit = () => {
    const submitButton = document.getElementById('new-submit-button');
    if (!submitButton) {
      return;
    }
    const form = submitButton.form;
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      submitButton.click();
    }
  };

  finishSaving = () => {
    let shouldResubmit = false;
    this.setState(
      prevState => {
        if (prevState.saveQueued) {
          shouldResubmit = true;
          return { isSaving: false, saveQueued: false };
        }
        return { isSaving: false };
      },
      () => {
        if (shouldResubmit) {
          this.requestProcedureSubmit();
        }
      }
    );
  };

  /**
   * Populate originalFieldValue (step names) from current form state so store_tree
   * persists name edits. The tree state often has originalFieldValue: null.
   */
  enrichTreeWithCurrentStepNames = tree => {
    if (
      !tree ||
      !tree.items ||
      typeof this.props.getProcedureStepNameAtIndex !== 'function'
    ) {
      return tree;
    }
    const nextTree = cloneDeep(tree);
    Object.keys(nextTree.items).forEach(itemId => {
      const item = nextTree.items[itemId];
      if (item && item.data && item.data.originalFieldIndex != null) {
        const name = this.props.getProcedureStepNameAtIndex(
          item.data.originalFieldIndex
        );
        if (name != null) {
          item.data.originalFieldValue = name;
        }
      }
    });
    return nextTree;
  };

  del = () => {
    if (window.confirm('Are you sure you want to delete this procedure?'))
      this.props.del(this.props.retrieved);
  };

  delNow = (item, event) => {
    event.target.disabled = true;
    event.target.innerHTML += '<span class="fa fa-spinner fa-spin"></span>';

    this.props.del(item);
  };

  setShow = (procedure, value) => {
    this.setState({
      procedureModals: {
        ...this.state.procedureModals,
        [procedure['@id']]: value
      }
    });
  };

  handleClose = procedure => this.setShow(procedure, false);

  handleShow = procedure => this.setShow(procedure, true);

  pressFormSubmit = () => {
    setTimeout(() => {
      this.setState({
        redirectToList: true
      });
    }, 100);
  };

  canRedirectToList = () => {
    if (this.state.redirectToList) {
      this.setState({
        redirectToList: false
      });

      return true;
    }

    return false;
  };

  drawerToggleClickHandler = () => {
    this.setState(prevState => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
  };

  backdropClickHandler = () => {
    this.setState({ sideDrawerOpen: false });
  };

  selectRootItem = (event, data, component) => {
    //
  };

  selectTreeItem = (data, index, component) => {
    this.props.changeFormField('procedure', 'category', data['@id']);
    let formCategoryName = this.props.getCategoryNameAtIndex(index);
    let dataCategoryName = data['name'];
    let categoryName =
      formCategoryName && formCategoryName !== dataCategoryName
        ? formCategoryName
        : dataCategoryName;
    this.props.changeFormField('procedure', 'categoryName', categoryName);

    setTimeout(() => {
      let submitButton = document.getElementById('new-submit-button');
      if (submitButton) {
        submitButton.click(); // handleBlur
      }
      this.backdropClickHandler();
    }, 1000);

    // close the drawer quicker
    setTimeout(() => {
      this.backdropClickHandler();
    }, 100);
  };

  exportPdfProcedure = (item, event) => {
    event.preventDefault();
    this.props.exportPdfProcedure(item);
  };

  addProcedureStep = (item, event) => {
    event.preventDefault();
    let elem = document.getElementById('add-procedure-step');
    if (elem) {
      elem.click();
    }
  };

  retrieveProcedure = () => {
    this.props.retrieve(decodeURIComponent(this.props.match.params.id));
  };

  render() {
    if (this.props.deleted) {
      this.props.delReset();
      return <Redirect to=".." />;
    }

    if (this.canRedirectToList()) {
      return <Redirect to=".." />;
    }

    const item =
      (this.props.updated &&
        this.props.updated['@id'] &&
        this.props.match.params.id &&
        this.props.updated['@id'] ===
          decodeURIComponent(this.props.match.params.id)) ||
      (this.props.updated &&
        this.props.retrieved &&
        this.props.updated['@id'] &&
        this.props.retrieved['@id'] &&
        this.props.updated['@id'] === this.props.retrieved['@id'])
        ? this.props.updated
        : this.props.retrieved;

    let backdrop;
    if (this.state.sideDrawerOpen) {
      backdrop = <Backdrop click={this.backdropClickHandler} />;
    }

    let lastSelectedCategoryId = false;
    if (item && item.category && item.category['@id']) {
      lastSelectedCategoryId = item.category['@id'].replace(/[^\d]*/, '');
    }

    return (
      <div className={'update-procedure mt-3'}>
        {/*
        <h1>Edit {item && item['@id']}</h1>
        */}

        {/*
        {this.props.created && (
          <div className="alert alert-success" role="status">
            {this.props.created['@id']} created.
          </div>
        )}
        */}
        {/*
        {this.props.created && (
          <div className="pull-right" role="status">
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <i className="fa fa-check"></i>
              </div>
            </div>
          </div>
        )}
        */}
        {/*
        {this.props.updated && (
          <div className="alert alert-success" role="status">
            {this.props.updated['@id']} updated.
          </div>
        )}
        */}
        {/*
        {this.props.updated && (
          <div className="pull-right" role="status">
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <i className="fa fa-check"></i>
              </div>
            </div>
          </div>
        )}
        */}
        {/*
        {(this.props.retrieveLoading ||
          this.props.updateLoading ||
          this.props.deleteLoading) && (
          <div className="alert alert-info" role="status">
            Loading...
          </div>
        )}
        */}
        {(this.props.retrieveLoading ||
          // this.props.updateLoading ||
          this.props.deleteLoading) && (
          <div className="pull-right" role="status">
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0 }}>
                Loading...
              </div>
            </div>
          </div>
        )}
        {this.props.retrieveError && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.retrieveError}
          </div>
        )}
        {this.props.updateError && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.updateError}
          </div>
        )}
        {this.props.deleteError && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.deleteError}
          </div>
        )}

        <div
          className={`form-actions-wrapper${
            this.state.isSticky ? ' yellow-sticky' : ''
          }`}
          ref={ref => (this._stickyHeader = ref)}
        >
          <div className={'form-actions'}>
            {/*
            <Link to=".." className="btn btn-primary pull-left">
              All Procedure Templates
            </Link>
            */}
            <button
              onClick={() =>
                this.handleShow({
                  '@id': 'delete_' + item['@id']
                })
              }
              className="btn btn-danger"
            >
              {/* Delete This Procedure */}
              {/*Delete This Template*/}
              Delete This Case Workflow
            </button>
            <Modal
              show={
                (item && this.state.procedureModals['delete_' + item['@id']]) ||
                false
              }
              onHide={() =>
                this.handleClose({
                  '@id': 'delete_' + item['@id']
                })
              }
              centered
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {/* Are you sure you want to delete this Procedure? */}
                  {/*Are you sure you want to delete this Template?*/}
                  Are you sure you want to delete this Case Workflow?
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>This will delete:</p>
                <ul>
                  {/* <li>This Procedure</li>
                  <li>All Steps in this Procedure</li> */}
                  {/*<li>This Template</li>*/}
                  {/*<li>All Steps in this Template</li>*/}
                  <li>This Case Workflow</li>
                  <li>All Steps in this Case Workflow</li>
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className={'btn'}
                  onClick={() =>
                    this.handleClose({
                      '@id': 'delete_' + item['@id']
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  className={'btn btn-danger'}
                  onClick={event => this.delNow(item, event)}
                >
                  {/* Delete Procedure */}
                  {/*Delete Template*/}
                  Delete Case Workflow
                </button>
              </Modal.Footer>
            </Modal>
            {/*
            <button
              onClick={() => window.print()}
              className="btn btn-info btn-yellow pull-left"
            >
              Print
            </button>
            */}
            {/*
            <button
              onClick={event => this.exportPdfProcedure(item, event)}
              className="btn btn-info btn-yellow pull-left"
            >
              Export PDF
            </button>
            */}
            {/*<button*/}
            {/*  onClick={event => this.addProcedureStep(item, event)}*/}
            {/*  className="btn btn-info btn-yellow"*/}
            {/*>*/}
            {/*  Add a Step*/}
            {/*</button>*/}
          </div>
        </div>

        {item && (
          <Form
            onSubmit={values => {
              if (this.state.isSaving) {
                this.setState({ saveQueued: true });
                return;
              }

              // Don't start a save cycle while a step is still being created.
              // The tree contains a placeholder with no originalId; saving now
              // would send incomplete data to store_tree or, worse, let the PUT
              // response replace the local tree with wrong positions.
              // keyboard.js submitAfterCreate will re-trigger onSubmit once the
              // create resolves and the item has a real ID.
              const internalTree = this.getFormComponent()
                ?.ref?.wrappedInstance?.wrapped?.getTreeComponent()
                ?.getTreeComponent();
              let hasUnresolved = false;
              if (internalTree) {
                const treeData = internalTree.getTreeComponentTree();
                hasUnresolved = Object.keys(treeData.items).some(itemId => {
                  const it = treeData.items[itemId];
                  return (
                    it &&
                    it.data &&
                    !it.data.isRemoved &&
                    itemId !== treeData.rootId &&
                    !it.data.originalId
                  );
                });
                if (hasUnresolved) {
                  return;
                }
              }

              this.setState({ isSaving: true });

              // Send full form values, but explicitly strip structural fields from procedureSteps so we
              // only update step metadata (e.g. name, description) and do not touch parent / children /
              // level / position. Step order is still managed by store_tree; the API denormalizer also
              // unsets position so the PUT does not drive order.
              const putValues = { ...values };
              if (putValues.procedureSteps) {
                Object.keys(putValues.procedureSteps).forEach(index => {
                  const step = putValues.procedureSteps[index];
                  if (!step) {
                    return;
                  }
                  delete step.parent;
                  delete step.children;
                  delete step.position;
                  delete step.level;
                });
              }

              const putPromise = this.props.update(item, putValues);
              const isPromise =
                putPromise && typeof putPromise.then === 'function';

              const runStoreTree = () => {
                const internalTree = this.getFormComponent()
                  ?.ref?.wrappedInstance?.wrapped?.getTreeComponent()
                  ?.getTreeComponent();
                if (!internalTree) {
                  this.finishSaving();
                  return;
                }
                let treeData = internalTree.getTreeComponentTree();

                const hasUnresolvedItems = Object.keys(treeData.items).some(
                  itemId => {
                    const it = treeData.items[itemId];
                    return (
                      it &&
                      it.data &&
                      !it.data.isRemoved &&
                      itemId !== treeData.rootId &&
                      !it.data.originalId
                    );
                  }
                );

                if (hasUnresolvedItems) {
                  this.setState({ skipTreeSyncUntilNextStoreTree: true });
                  this.finishSaving();
                  return;
                }

                this.setState({ skipTreeSyncUntilNextStoreTree: false });
                treeData = this.enrichTreeWithCurrentStepNames(treeData);
                const storeTreePromise = internalTree.onTreeUpdated(
                  treeData,
                  'manual_submit'
                );
                const hasStoreTreePromise =
                  storeTreePromise &&
                  typeof storeTreePromise.then === 'function';
                if (hasStoreTreePromise) {
                  storeTreePromise.finally(() => this.finishSaving());
                } else {
                  this.finishSaving();
                }
              };

              if (isPromise) {
                putPromise.then(runStoreTree).catch(() => {
                  this.finishSaving();
                });
              } else {
                runStoreTree();
              }
            }}
            initialValues={item}
            changeFormField={this.props.changeFormField}
            allowAutoSave={false}
            pressFormSubmit={this.pressFormSubmit}
            drawerToggleClickHandler={this.drawerToggleClickHandler}
            getProcedureStepNameAtIndex={this.props.getProcedureStepNameAtIndex}
            retrieveProcedure={this.retrieveProcedure}
            retrievedProcedure={this.props.retrieved}
            saving={this.state.isSaving}
            suppressTreeSyncFromResponse={
              this.state.skipTreeSyncUntilNextStoreTree
            }
            ref={this.attachNode.bind(this)}
          />
        )}

        {item && (
          <SideDrawer show={this.state.sideDrawerOpen}>
            <div className={'ml-2 mr-2'}>
              <CategoryTreeSelectionForm
                isDraggingEnabled={true}
                displayAddButton={true}
                displayEditItemButton={true}
                displayDeleteItemButton={true}
                displaySelectItemButton={true}
                lastSelectedFieldIndex={lastSelectedCategoryId}
                selectRootItem={this.selectRootItem}
                selectTreeItem={this.selectTreeItem}
                allowEnterKey={false}
              />
            </div>
          </SideDrawer>
        )}
        {backdrop}
      </div>
    );
  }
}

const procedureFormSelector = formValueSelector('procedure');
const categoryFormSelector = formValueSelector('category');

const mapStateToProps = state => ({
  getProcedureStepNameAtIndex: index =>
    procedureFormSelector(state, 'procedureSteps[' + index + '][name]'),
  getCategoryNameAtIndex: index =>
    categoryFormSelector(state, 'rootChildren[' + index + '][name]'),
  retrieved: state.procedure.update.retrieved,
  retrieveError: state.procedure.update.retrieveError,
  retrieveLoading: state.procedure.update.retrieveLoading,
  updateError: state.procedure.update.updateError,
  updateLoading: state.procedure.update.updateLoading,
  deleteError: state.procedure.del.error,
  deleteLoading: state.procedure.del.loading,
  eventSource: state.procedure.update.eventSource,
  created: state.procedure.create.created,
  deleted: state.procedure.del.deleted,
  updated: state.procedure.update.updated
});

const mapDispatchToProps = dispatch => ({
  exportPdfProcedure: item => dispatch(exportPdfProcedure(item)),
  delReset: () => dispatch(delSuccess(null)),
  changeFormField: (form, field, value) =>
    dispatch(changeFormField(form, field, value)),
  retrieve: id => dispatch(retrieve(id)),
  update: (item, values) => dispatch(update(item, values)),
  del: item => dispatch(del(item)),
  reset: eventSource => dispatch(reset(eventSource))
});

export default connect(mapStateToProps, mapDispatchToProps)(Update);
